import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Sparkles, Zap, Check } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const cloneImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/syVWaorgSVczDCWoZ1TajY/freepik__la-misma-chica-de-la-imag1-caminando-por-la-calle-__66530.png',
    label: 'Exterior'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/iXx9X8r568xVSYS9bHFRrp/freepik__la-misma-chica-de-la-imag1-closeup-frontal-del-ros__66529.png',
    label: 'Closeup'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/1eZ4ueWYCG4HtseEw8WfTL/freepik__la-misma-chica-de-la-imag1-closeup-extremo-del-ros__66527.png',
    label: 'Detalle'
  }];
  return <section className="relative min-h-screen flex items-center pt-20 pb-16 px-5 overflow-hidden" data-id="element-76">
      {/* Background Effects */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#00d4ff]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-77" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#7c3aed]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-78" />

      <div className="max-w-7xl mx-auto w-full grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-79">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col gap-6" data-id="element-80">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 w-fit" data-id="element-81">
            <Sparkles className="w-4 h-4 text-[#00d4ff]" data-id="element-82" />
            <span className="text-sm font-medium text-gray-300" data-id="element-83">
              El Método Operativo Definitivo
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight" data-id="element-84">
            Deja de Jugar a la{' '}
            <span className="text-gradient-cyan" data-id="element-85">"Lotería de Prompts"</span> y
            Construye una Identidad Virtual Inquebrantable.
          </h1>

          <p className="text-lg md:text-xl text-gray-400 leading-relaxed max-w-xl" data-id="element-86">
            El sistema exacto para crear Clones IA Hiperrealistas con
            consistencia total, sin que el rostro cambie en cada generación.
          </p>

          <div className="pt-4 flex flex-col sm:flex-row gap-4" data-id="element-87">
            <Button onClick={scrollToPricing} fullWidth className="sm:w-auto" data-id="element-88">
              QUIERO EL MÉTODO DEFINITIVO
              <Zap className="w-5 h-5 ml-1" data-id="element-89" />
            </Button>
          </div>

          <div className="flex items-center gap-3 pt-4" data-id="element-90">
            <div className="flex -space-x-2" data-id="element-91">
              {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full border-2 border-[#0a0a0f] bg-gray-800 flex items-center justify-center overflow-hidden" data-id="element-92">
                  <div className="w-full h-full bg-gradient-to-br from-gray-700 to-gray-900" data-id="element-93" />
                </div>)}
            </div>
            <div className="flex flex-col" data-id="element-94">
              <div className="flex items-center gap-1" data-id="element-95">
                {[1, 2, 3, 4, 5].map(i => <svg key={i} className="w-4 h-4 text-yellow-500" fill="currentColor" viewBox="0 0 20 20" data-id="element-96">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-97" />
                  </svg>)}
              </div>
              <span className="text-xs text-gray-400" data-id="element-98">
                Utilizado por agencias top.
              </span>
            </div>
          </div>
        </motion.div>

        {/* Real Clone Photos */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full" data-id="element-99">
          {/* Header badge */}
          <div className="flex items-center gap-2 mb-4" data-id="element-100">
            <ShieldCheck className="w-4 h-4 text-[#00d4ff]" data-id="element-101" />
            <span className="text-[#00d4ff] text-sm font-bold uppercase tracking-wider" data-id="element-102">
              Un clon — Infinitos escenarios
            </span>
          </div>

          {/* Photo Grid */}
          <div className="grid grid-cols-3 gap-2 md:gap-3" data-id="element-103">
            {cloneImages.map((img, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 15
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4 + i * 0.12
          }} className="relative aspect-[3/4] rounded-xl overflow-hidden group" data-id="element-104">
                <img src={img.src} alt={img.label} className="absolute inset-0 w-full h-full object-cover" data-id="element-105" />
                {/* Subtle overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-106" />
                {/* Label */}
                <div className="absolute top-2 left-2" data-id="element-107">
                  <span className="text-[10px] md:text-xs text-white/70 font-semibold uppercase tracking-wider bg-black/40 backdrop-blur-sm px-2 py-0.5 rounded" data-id="element-108">
                    {img.label}
                  </span>
                </div>
                {/* Check */}
                <div className="absolute bottom-2 right-2" data-id="element-109">
                  <div className="w-6 h-6 rounded-full bg-[#00d4ff]/20 border border-[#00d4ff]/50 flex items-center justify-center backdrop-blur-sm" data-id="element-110">
                    <Check className="w-3.5 h-3.5 text-[#00d4ff]" data-id="element-111" />
                  </div>
                </div>
                {/* Border */}
                <div className="absolute inset-0 rounded-xl border border-[#00d4ff]/15" data-id="element-112" />
              </motion.div>)}
          </div>

          <p className="text-[#00d4ff]/60 text-xs mt-3 text-center" data-id="element-113">
            Mismo rostro, misma identidad — generado con IA
          </p>
        </motion.div>
      </div>
    </section>;
}